import React from 'react';
import { InvoiceTypeConstants, InvoiceStatusConstants } from '../constants/invoiceConstants';

interface BadgeConfig {
  text: string;
  colorClass: string;
}

export const getInvoiceTypeBadge = (typeId?: string, typeName?: string): BadgeConfig => {
  if (!typeId) {
    return {
      text: typeName || 'Unknown',
      colorClass: 'bg-gray-100 text-gray-800',
    };
  }

  switch (typeId) {
    case InvoiceTypeConstants.Standard:
      return {
        text: typeName || 'Standard',
        colorClass: 'bg-blue-100 text-blue-800',
      };
    case InvoiceTypeConstants.CreditNote:
      return {
        text: typeName || 'Credit Note',
        colorClass: 'bg-red-100 text-red-800',
      };
    default:
      return {
        text: typeName || 'Unknown',
        colorClass: 'bg-gray-100 text-gray-800',
      };
  }
};

export const getInvoiceStatusBadge = (statusId?: string, statusName?: string): BadgeConfig => {
  if (!statusId) {
    return {
      text: statusName || 'Unknown',
      colorClass: 'bg-gray-100 text-gray-800',
    };
  }

  switch (statusId) {
    case InvoiceStatusConstants.Draft:
      return {
        text: statusName || 'Draft',
        colorClass: 'bg-gray-100 text-gray-800',
      };
    case InvoiceStatusConstants.Issued:
      return {
        text: statusName || 'Issued',
        colorClass: 'bg-yellow-100 text-yellow-800',
      };
    case InvoiceStatusConstants.Paid:
      return {
        text: statusName || 'Paid',
        colorClass: 'bg-green-100 text-green-800',
      };
    case InvoiceStatusConstants.PartiallyPaid:
      return {
        text: statusName || 'Partially Paid',
        colorClass: 'bg-orange-100 text-orange-800',
      };
    case InvoiceStatusConstants.Credited:
      return {
        text: statusName || 'Credited',
        colorClass: 'bg-purple-100 text-purple-800',
      };
    case InvoiceStatusConstants.Cancelled:
      return {
        text: statusName || 'Cancelled',
        colorClass: 'bg-red-100 text-red-800',
      };
    default:
      return {
        text: statusName || 'Unknown',
        colorClass: 'bg-gray-100 text-gray-800',
      };
  }
};

export const renderInvoiceTypeBadge = (typeId?: string, typeName?: string): JSX.Element => {
  const { text, colorClass } = getInvoiceTypeBadge(typeId, typeName);
  return (
    <span className={`px-2 py-1 text-xs font-semibold rounded-full ${colorClass}`}>
      {text}
    </span>
  );
};

export const renderInvoiceStatusBadge = (statusId?: string, statusName?: string): JSX.Element => {
  const { text, colorClass } = getInvoiceStatusBadge(statusId, statusName);
  return (
    <span className={`px-2 py-1 text-xs font-semibold rounded-full ${colorClass}`}>
      {text}
    </span>
  );
};